<template>
  <div>
    <div class="container" v-if="fill_info == ''">
      <div class="row">
        <div class="col-xs-12 col-md-3">

          <div class="panels">

          </div>
        </div>

        <!-- Űrlap -->
        <div class="col-xs-12 col-md-9">
          <div class="form-title">Korrekciós kérelem</div>

          <!-- ------------------------------ Hallgató Adatok ------------------------------ -->

          <HallgatoAdatok v-on:onReady="(hallgato,hallgato_szakok) => {this.save_enabled = true;this.hallgato = hallgato;this.hallgato_szakok = hallgato_szakok}"></HallgatoAdatok>

          <!-- ------------------------------ Pályázati adatok ------------------------------ -->

          <h5 class="form-block-title-layout-tab">
            <span>Kérelem adatok</span>
          </h5>

          <div class="form-group">
            <label class="form-label">
              Korrekció tárgya
            </label>
            <select class="form-control" name="kerelem_targya" id="kerelem_targya" v-model="form.Targy">
              <option v-for="(targy, i) in targyak" :value="targy.value">{{ targy.text }}</option>
            </select>
            <div v-if="error.id == 'Targy'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
          <textareabox :errors="errors" cstyle="min-height: 100px" maxlength="2000" :autogrow="true" iconclass="fa fa-pencil" id="Indoklas" label="Indoklás" name="Indoklas" v-model="form.Indoklas"/>

          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save" type="button" name="kuld" :disabled="!save_enabled" class="button">Beküld</button>
          </div>
        </div>

      </div>
    </div>
    <div class="container" v-show="fill_info != ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">Korrekciós kérelem</div>
          <div class="article-text" v-html="fill_info">{{ fill_info }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import HallgatoAdatok from './hatar_hallgato_adatok.vue';

export default {
  components: {
    HallgatoAdatok
  },

  data: function() {
    return {
      fill_info: '',
      save_enabled: false,
      errors: [],
      form: {
        Indoklas: '',
        Targy: 'Rendszeres szociális támogatás és Lakhatási támogatás'
      },
      targyak: [
        {"value":"Rendszeres szociális támogatás és Lakhatási támogatás","text":"Rendszeres szociális támogatás és Lakhatási támogatás"},{"value":"Költségtérítés mérséklés","text":"Költségtérítés mérséklés"},{"value":"Kollégium","text":"Kollégium"}
      ],
      hallgato: {},
      hallgato_szakok: {}
    }
  },
  mounted: function() {
  	var _this = this;
    _this.urlapKitoltheto();
  },
  methods: {
    urlapKitoltheto: function() {
      var _this = this;
      this.$root.ajax('hatar/urlap_kitoltheto/RendszeresSzocialisKorrekciosKerelem/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            if (!response.kitoltheto)
              _this.fill_info = 'Az űrlap nem tölthető ki.';
          }
        }
      });
    },

    save: function() {
      var _this = this;

      this.errors = [];

      this.$root.ajax('hatar/ment/korrekcio_kerelem/', {
        method: 'POST',
        data: {
          form: this.form,
          hallgID: this.hallgato.HallgID,
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// korrekcios_kerelem.vue?ba0703c4